import { Overlay } from '@angular/cdk/overlay';
import { Component, Input, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Auth } from 'src/app/models/auth';
import { Pedido } from 'src/app/models/pedido';
import { Purchase, PurchasesList } from 'src/app/models/purchase';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ContratoService } from 'src/app/services/contrato.service';
import { PedidoDataService } from 'src/app/services/pedido-data.service';
import { PedidoService } from 'src/app/services/pedido.service';
import { NewAlertService } from 'src/app/shared/components/new-alert/new-alert.service';
import { ApiError } from 'src/app/shared/enums/api-error.enum';
import { SituacaoCompra } from 'src/app/shared/enums/situacao-compra.enum';
import { SituacaoPedido } from 'src/app/shared/enums/situacao-pedido.enum';
import { StatusMinhasComprasList } from 'src/app/shared/enums/status-minhas-compras-list.enum';
import { PurchaseConverter } from 'src/app/shared/helpers/converters/purchase-converter';


@Component({
  selector: 'app-compras-anteriores',
  templateUrl: './compras-anteriores.component.html',
  styleUrls: ['./compras-anteriores.component.css']
})
export class ComprasAnterioresComponent implements OnInit {

  public currentUser: Auth;
  public pedidos: Pedido[];
  public pedidosList: Pedido[];
  public SituacaoPedido = SituacaoPedido;

  public purchases: PurchasesList;
  public purchasesList: Purchase[];
  public SituacaoCompra = SituacaoCompra;

  public StatusMinhasComprasList = StatusMinhasComprasList;
  //#region Messages
  public messageError: string = null;
  //#endregion

  //#region Filtro
  @Input() filtroPesquisa: string;
  //#endregion

  //#region Ordenação
  sortOrder: boolean;
  //#endregion

  //#region Paginação
  public offSet = 0;
  public currentPage = 1;
  showItem = '10';
  public totalPages: number;
  public totalPurchases: number;
  //#endregion

  //#region Reprocessar Pedido
  public pedidoToReprocessar: Purchase;
  //#endregion

  //#region Cancelar Pedido
  public cancelCount: number;
  public selectAll: boolean;
  public pedidoToCancel: Purchase;
  //#endregion

  @ViewChild('novobaneficio', { static: true }) novoBeneficio: TemplateRef<any>;

  constructor(
    private pedidoService: PedidoService,
    private authenticationService: AuthenticationService,
    private alertService: NewAlertService,
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    public overlay: Overlay,
    public viewContainerRef: ViewContainerRef,
    private contratoService: ContratoService,
    private pedidoDataService: PedidoDataService) {
  }

  ngOnInit() {
    this.currentUser = this.authenticationService.currentUserValue;

    if(sessionStorage.getItem('currentPageC') != null){
      this.currentPage = parseInt(sessionStorage.getItem('currentPageC'));
      sessionStorage.removeItem('currentPageC');
      this.changePage(this.currentPage);
    } else{
      this.loadList();
    }
  }

  loadList() {
    this.pedidoService.getPurcharses([SituacaoCompra.ProcessadoComSucesso, SituacaoCompra.NaoProcessado, SituacaoCompra.Cancelado, SituacaoCompra.ParcialmenteProcessado],this.currentUser.token.assignorGuid, this.offSet, this.showItem).subscribe(
      response => {
          if (response.status === ApiError.Sucesso) {
            this.purchases = response.result;
            this.purchasesList = this.purchases.purchases;

            this.totalPages =  this.purchases.totalPages;
            this.totalPurchases =  this.purchases.totalPurchases;
          } else if (response.status == ApiError.Insucesso){
            this.messageError = response.message;
          } else {
            this.alertService.error(response.message);
          }
        }, error => { this.alertService.error(error); }
      );
  }

  reloadList() {
    const tempList = this.purchases.purchases;
    // filtros
    this.purchasesList = tempList;
    this.totalPages =  this.purchases.totalPages;
    this.totalPurchases =  this.purchases.totalPurchases;
  }

  details(purchase: Purchase) {
    sessionStorage.setItem('currentPageC',this.currentPage.toString());
    sessionStorage.setItem('statusMinhasComprasList',this.StatusMinhasComprasList.ComprasAnteriores.toString());
    this.router.navigate([`details/${purchase.purchaseId}`], { relativeTo: this.route.parent });
  }

  //#region Paginacao
    changePage(event) {
      this.currentPage = event;
      this.offSet = this.currentPage - 1;
      this.loadList();
      this.selectAll = false;
    }

    changeLimit(event){
      this.showItem = event;
      this.currentPage = this.currentPage;
      this.offSet = this.currentPage - 1;
      this.loadList();
      this.selectAll = false;
    }
  //#endregion

  //#region Filtros

  orderBy(collumnName: string, sortOrder: boolean) {
    this.purchasesList.sort(
      (a, b) => {
        const dftl = sortOrder ? Number.MAX_VALUE : -Number.MAX_VALUE;
        const aVal = (a[collumnName] === null ? dftl : a[collumnName]).toString();
        const bVal = (b[collumnName] === null ? dftl : b[collumnName]).toString();
        let result = aVal.localeCompare(bVal, undefined, { numeric: true });
        if (sortOrder) {
          result = bVal.localeCompare(aVal, undefined, { numeric: true });
        }
        return result;
      }
    );
  }

  //#endregion

  //#region ReprocessarPedido
  showReprocessar(content: any, purchase: Purchase) {
    this.pedidoToReprocessar = purchase;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  reprocessar(purchase: Purchase) {
    this.pedidoService.reprocessPurchase(purchase.purchaseId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success(response.message);
          this.loadList();
          this.reloadList();
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error); }
    );
  }
  //#endregion

  //#region Cancelar Pedido
  showCancel(content: any, purchase: Purchase) {
    this.pedidoToCancel = purchase;
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  cancel(purchase: Purchase) {
    this.pedidoService.cancelPurchase(purchase.purchaseId, this.currentUser.token.assignorGuid, this.currentUser.token.userReferenceId).subscribe(
      response => {
        if (response.status === ApiError.Sucesso) {
          this.alertService.success(response.message);
          this.loadList();
          this.reloadList();
        } else {
          this.alertService.error(response.message);
        }
      }, error => { this.alertService.error(error); }
    );
  }

  updateCancelCount() {
    this.cancelCount = this.purchasesList.filter(x => x.toCancel).length;
  }

  selectAllToCancel(value: boolean) {
    this.purchasesList.forEach(obj => {
      if (obj.situacaoId === SituacaoCompra.EmCriacao || obj.situacaoId === SituacaoCompra.Criado || obj.situacaoId === SituacaoCompra.NaoProcessado) {
        obj.toCancel = value;
      }
    });
    this.updateCancelCount();
  }

  showCancelAll(content: any) {
    this.updateCancelCount();
    this.modalService.open(content, { centered: true, size: 'lg' });
  }

  cancelAllSelected() {
    this.purchasesList.forEach(obj => {
      if (obj.toCancel) {
        this.cancel(obj);
      }
    });
    this.updateCancelCount();
  }
  //#endregion

  copiar(purchase: Purchase) {
    if (purchase.situacaoId !== SituacaoCompra.EmCriacao) {
      this.pedidoService.getPurchaseById(purchase.purchaseId, this.currentUser.token.assignorGuid, false).subscribe(
        response => {
            if (response.status === ApiError.Sucesso) {
                this.pedidoDataService.setCurrentPurchaseValue(PurchaseConverter.purchaseToNewPurchase(response.result));
                if(response.result.isFlexPurchase){
                    this.router.navigate(['portal/novarecarga/selecionargrupocolaborador']);
                }else{
                    this.router.navigate(['portal/novarecarga/selecionarcolaborador']);
                }
            } else {
                this.alertService.error(response.message);
            }
        }, error => { this.alertService.error(error.error); }
      );
    } else {
      this.alertService.error('Situação inválida para copiar o pedido');
    }
  }
}
